import React, {useRef, useState} from 'react';
import {Pressable, View} from 'react-native';
import OTPTextInput from 'react-native-otp-textinput';
import OtpInput from 'react-otp-input';
import {ThemeProvider} from '@rneui/themed';
import {Card} from '@rneui/themed';
import {Image} from '@rneui/themed';
import {ErrorMessage as FormikErrorMessage, Formik} from 'formik';
import {observer} from 'mobx-react-lite';
import * as Yup from 'yup';

import AddToWallet from '../../components/rewards/AddToWallet';
import InStoreCode from '../../components/rewards/InStoreCode';
import MemberCard from '../../components/rewards/MemberCard';
import RewardsProgramImage from '../../components/rewards/ProgramImage';
import Button from '../../components/themed/Button';
import KeyboardAwareScrollView from '../../components/themed/KeyboardAwareScrollView';
import Text from '../../components/themed/Text';
import TextInput from '../../components/themed/TextInput';
import Otp from '../../components/ui-controls/form/Otp';
import ValidationMessage from '../../components/ui-controls/form/ValidationMessage';
import ContentView from '../../components/ui-controls/layout/ContentView';
import {fontFamilyStyle} from '../../components/ui-controls/Text';
import logoImg from '../../images/brand/header-logo.png';
// import CheckboxComponent from '../../components/ui-controls/web/CheckBox';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import {navigate} from '../../navigation/RootNavigation';
import {useStores} from '../../stores/use-stores';
import rewardsTheme from '../../theme/rewardsTheme';
import apiService from '../../transport/apiService';
import {Analytics} from '../../utils/analytics/analytics';
import {
  EventName,
  EventScreenName,
  EventSourceType,
} from '../../utils/analytics/events';
import {rewardsMarketingName} from '../../utils/rewards';
import {SignInSchema} from '../rewards/validationSchema';

export interface RewardsSignInParams {
  phoneNumber: string;
}

const KitchenSinkCardScreen = observer(
  ({route}: RouteNavigatorScreenProps<AppRoute.KITCHENSINK_INDEX>) => {
    const [isSubmitting, setSubmitting] = useState(false);

    const onSubmit = async (values: SignInValues) => {
      setSubmitting(true);
      try {
        const result = await apiService.rewardsSignIn(values);
        if (result?.status === 200) {
          if (result.data?.exists) {
            navigate(AppRoute.REWARDS_VERIFICATION);
          } else {
            navigate(AppRoute.REWARDS_SIGN_UP);
          }
        }
      } catch (e) {}
      setSubmitting(false);
    };

    const validationSchema = SignInSchema;

    type SignInValues = Yup.InferType<typeof validationSchema>;

    const defaultValues: SignInValues = {
      phoneNumber: '',
    };

    return (
      <ThemeProvider theme={rewardsTheme}>
        <KeyboardAwareScrollView keyboardShouldPersistTaps="always">
          <Formik
            initialValues={defaultValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}>
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              initialValues,
              setFieldValue,
              setFieldError,
              setFieldTouched,
              touched,
              values,
            }) => {
              return (
                <ContentView>
                  <Text variant="heading0">CONGRATULATIONS</Text>
                  <View style={{gap: 8}}>
                    <MemberCard
                      logoImg={logoImg}
                      cardNumber="234234"
                      name="David Gyte"
                    />
                    <InStoreCode inStoreCode="BM 1245" />
                    <AddToWallet />
                  </View>
                  <Text
                    variant="body2"
                    style={{fontWeight: 600, marginTop: 40}}>
                    Make sure you present your membership card at checkout every
                    time you shop to take advantage of all your{' '}
                    {rewardsMarketingName}
                    offers.
                  </Text>
                  <Text variant="body2">
                    {'\n'}
                    Although your account is ready to go, we have sent you an
                    email to complete the last few steps and give you access to
                    our website to see all of your member benefits.
                    {'\n\n'}
                    These benefits updated regularly, so it’s a great way to
                    stay connected to your personalised rewards. You can do this
                    now by hitting the continue button.
                  </Text>
                  <View style={{gap: 8, marginTop: 40}}>
                    <Button
                      title={'CONTINUE'}
                      // onPress={handleSubmitPress}
                      // disabled={isSubmitting}
                      // loading={isSubmitting}
                    />

                    <Button
                      variant="outlined"
                      title={'CLOSE'}
                      onPress={() => {}}
                    />
                  </View>
                </ContentView>
              );
            }}
          </Formik>
        </KeyboardAwareScrollView>
      </ThemeProvider>
    );
  },
);

export default KitchenSinkCardScreen;
